
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code2 } from "@/views/resources/documentation/element-ui/basic/space/code";

export default defineComponent({
  name: "vertical-layout",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code2
    };
  }
});
